import React from "react";
import Lottie from "react-lottie";
import modalpopup from "../../assets/images/modalPopubg.svg";
import { ModalPopUp } from "../ModalPopUp/ModalPopUp";
import animationData1 from "../../assets/lotties/question.json";

function ConfirmBox({
  children,
  type = "confirm",
  cancelBtn = "No, Cancel it",
  okBtn = "  Yes, I am sure!",
  cancel = () => {},
  ok = () => {},
  height=undefined,
  isLoding=false
}) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };
  return (
    <>
      <ModalPopUp>
        <div
          className="modal-popup"
          style={{
            backgroundImage: `url(${modalpopup})`,
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "right",
            backgroundPositionY: "bottom",
            height: height?height: "270px",
          }}
        >
          <div className="">
            {type === "confirm" ? (
              <Lottie options={defaultOptions} height={80} width={80}></Lottie>
            ) : (
              ""
            )}
          </div>

          <div className="flex justify-center ">
            <label className="fs25 blue_font fw-bold">
              {type === "confirm" ? "Are you sure!" : ""}
            </label>
          </div>
          <div className="flex justify-center">{children}</div>
          <div className="flex justify-center gap-10 mt-30">
            <button
              onClick={cancel}
              style={{
                height: "45px",
                width: "150px",
                backgroundColor: "#EDFAFE",
                color: "#00286F",
                border: "none",
                borderRadius: "5px",
              }}
              disabled={isLoding}
            >
              {cancelBtn}
            </button>
            <button
              onClick={ok}
              style={{
                height: "45px",
                width: "150px",
                backgroundColor: "#00BAF2",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "5px",
              }}
                 disabled={isLoding}
            >
              {okBtn}
            </button>
          </div>
        </div>
      </ModalPopUp>
    </>
  );
}

export default ConfirmBox;
